import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=15991c74&"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports